import { AbstractControl, ValidationErrors } from '@angular/forms';

export function quantityValidator(maxQuantity: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const quantity = control.value;
    if (quantity > maxQuantity) {
      return { quantityExceeded: true };
    }
    return null;
  };
}
